<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row>
      <v-col cols="1" class="pa-5"></v-col>
      <v-col class="pa-5 col-9 col-md-4"><v-img src="img/cpa.png" /></v-col>
      <v-col class="pa-5 cols-9 col-md-6">
        <router-link to="/farroupilha"><div class="mb-3"><v-img src="img/visitar-clube-farroupilha.png" /></div></router-link>
        <router-link to="/viamao"><div class="mb-3"><v-img src="img/visitar-clube-viamao.png" /></div></router-link>
      </v-col>
      <v-col cols="1" class="pa-5"></v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    snackbar: true
  })
}
</script>
